<template>
    <form class="shift">
        <h4>{{mode === 'addShift' ? $t('addingShift') : $t('editingShift')}}</h4>
        <v-text-field outlined dense :label="$t('shiftName')" v-model="shiftObj.name"/>
        <div class="btn-actions" v-if="mode === 'addShift'">
            <v-btn color="red" @click="closeModal">{{ $t('cancel') }}</v-btn>
            <v-btn color="green" @click="createShift" :disabled="!shiftObj.name">{{ $t('next') }}</v-btn>
        </div>
    </form>
</template>

<script>
export default {
  props: {
    shiftObj: Object,
    mode: String
  },

  methods: {
    createShift () {
      this.$emit('createShift')
    },
    closeModal () {
      this.$emit('closeModal')
    }
  }
}
</script>
